import script from "./FavoritesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FavoritesSection.vue?vue&type=script&setup=true&lang=ts"

import "./FavoritesSection.vue?vue&type=style&index=0&id=d54bdfd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d54bdfd0"]])

export default __exports__